import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Questionnaire from "@/pages/Questionnaire";
import Results from "@/pages/Results";
import Admin from "@/pages/Admin";
import RecentSales from "@/pages/RecentSales";
import GATracker from "@/components/GATracker";

function App() {
  return (
    <>
      <BrowserRouter>
        <GATracker />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/valuation" element={<Questionnaire />} />
          <Route path="/recent-sales" element={<RecentSales />} />
          <Route path="/results/:id" element={<Results />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </>
  );
}

export default App;
